export default {
	showAddFeedback: false,  

   	showLoader: false,  	

   	feedbackPublishList: [],
   	category_name: '',
}
